import React, {useEffect} from 'react';
import {ModalStyled} from "../../../styled/Modal";
import { IoCheckmarkCircle } from "react-icons/io5";
import { MdCancel } from "react-icons/md";
import Button from "../Buttons/Button";
import { Rating } from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";
import {setPricingDetails, setShowCheckout} from "../../../redux/states";
import {CheckoutSummaryModal} from "../Modal/Modal";



const Modal = (props) => {
    const {open, setOpen, plan, title} = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showCheckout } = useSelector(state => state.stateData)
    const prevPath = sessionStorage.getItem('prevPath') || '/';

    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [open]);

    if (!open) return null;

    const handleClick = (item) => {
        const pricingObject = {
            product: title,
            duration: item.duration,
            price: item.price,
            currency: item.currency
        };
        dispatch(setPricingDetails(pricingObject));
        dispatch(setShowCheckout(true));
    }


    return (
        <ModalStyled className='BubblePopIn' $mobile={"true"}>
            <h2>{title} Plans</h2>
            <div className="plans">
                {plan && plan.map((item, index) => (
                    <div key={index} className={item.popular ? 'planContainerMonth' : 'planContainer'}>
                        <div className="header">
                            <div className="firstColumn">
                                <h3>{item.duration}</h3>
                                <span className='price'>
                                    <p>{item.price} {item.currency}</p>
                                    {Number(String(item.discount).replace('%','')) > 0 && (
                                        <div>
                                            <p className='discount'>
                                                <span>{item.discount}%</span> off
                                            </p>
                                            <p className="strikethrough">
                                                {Math.round(
                                                        Number(item.price) /
                                                        (1 - Number(String(item.discount).replace('%', '')) / 100)
                                                    )
                                                } {item.currency}
                                            </p>
                                        </div>
                                    )}
                                </span>
                            </div>
                            {(item.duration === 'Per Use') && (
                                <div className='ratings'>
                                    <Rating name="read-only" value={3} size="small" readOnly />
                                </div>
                            )}
                            {(item.duration === 'Per Week' || item.duration === 'Student Plan') && (
                                <div className='ratings'>
                                    <Rating name="read-only" value={4} size="small" readOnly />
                                </div>
                            )}
                            {(item.duration === 'Per Month' || item.duration === 'Pro Plan' || item.duration === 'Per Year' || item.popular) && (
                                <div className='ratings' style={{textAlign: 'left'}}>
                                    <Rating name="read-only" value={5} size="small" readOnly />
                                    80% of successful users chose this plan
                                </div>
                            )}
                        </div>
                        <div className="featureContainer">
                            {item.features.map((feature, index) => (
                                <div key={index} className='feature'>
                                    {feature.available ? <IoCheckmarkCircle color="#009990"/> : <MdCancel color="red"/>}
                                    <p>{feature.text}</p>
                                </div>
                            ))}
                            <div className="button">
                                {item.popular ? (
                                    <Button
                                        $reccomended={"true"}
                                        $bg="linear-gradient(to left, rgba(111, 203, 209, 1), rgba(57, 104, 107, 1))"
                                        color="#fff"
                                        width="95%"
                                        $checkout={true}
                                        checkoutHandle={() => handleClick(item)}
                                    >
                                        Get Started
                                    </Button>
                                ) : item.duration && item.duration.includes('Free') ? (
                                    null
                                ) : (
                                    <Button
                                        width="95%"
                                        $borderColor="#fff"
                                        color="#fff"
                                        $checkout={"true"}
                                        checkoutHandle={() => handleClick(item)}
                                    >
                                        Get started
                                    </Button>
                                )}
                            </div>
                        </div>

                    </div>
                ))}
                <button
                    className='cancel-mobile'
                    onClick={() => {
                        if (typeof setOpen === 'function') {
                            setOpen(!open);
                        } else {
                            navigate(prevPath);
                        }
                    }}
                >
                    Cancel
                </button>
            </div>
            <button
                className='cancel-desktop'
                onClick={() => {
                    if (typeof setOpen === 'function') {
                        setOpen(!open);
                    } else {
                        navigate(prevPath);
                    }
                }}
            >
                Cancel
            </button>
            {showCheckout && <CheckoutSummaryModal />}


        </ModalStyled>


    )
}

export default Modal;